import Login from './Login';
import { useEffect, useState } from 'react';
const Layout = ({ children }) => {
  const [auth, setAuth] = useState(false);
  useEffect(() => {
    const token = window.localStorage.getItem('token');
    if (token) {
      setAuth(true);
    }
  }, []);
  return auth ? <>{children}</> : <Login setAuth={setAuth} />;
};

export default Layout;
